import(/* webpackMode: "eager" */ "/vercel/path0/src/app/student/guidance/page.tsx");
